var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "nav-item dropdown" }, [
    _c(
      "div",
      {
        staticClass:
          "btn btn-secondary btn-block btn-sm-lg navbar-btn dropdown-toggle me-1 mb-1",
        on: {
          click: function ($event) {
            $event.preventDefault()
            _vm.showDropdown = !_vm.showDropdown
          },
        },
      },
      [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
    ),
    _vm._v(" "),
    _vm.showDropdown
      ? _c(
          "div",
          {
            staticClass: "dropdown-menu",
            attrs: { "aria-labelledby": "navbarDropdownMenuLink" },
          },
          [
            _vm._l(_vm.filterValues, function (val) {
              return [
                _c("label", { staticClass: "dropdown-item" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.isActive(val) },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("toggle-filter", val)
                      },
                    },
                  }),
                  _vm._v(
                    "  " + _vm._s(_vm.displayValue(val)) + "\n            "
                  ),
                ]),
              ]
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }